<ui-cms
  [config]="config()"
  [notFoundPageEnabled]="true"
  (hasContent)="onLoadResult($event)"
  (pageLoaded)="onPageLoaded($event)"
></ui-cms>
